import React, { useEffect, useState } from "react"
import { useIdleTimer } from "react-idle-timer"
import Config from "react-global-configuration"
import { useApolloClient } from "@apollo/client"
import { useAuth } from "../../services"

const IdleTimer = ({ onLoggingOut }) => {
  const client = useApolloClient()
  const {
    logout,
    settings: { deviceTimer },
  } = useAuth(client)
  const { idleTimeoutMs } = Config.get("auth")
  const [ticker, setTicker] = useState(false)

  useEffect(() => {
    const run = setInterval(() => {
      setTicker(!ticker)
    }, 1000)
    return () => clearInterval(run)
  })

  const handleIdle = () => {
    console.log("[AUTH]", "User is idle, sign out...")
    onLoggingOut && onLoggingOut()
    logout("idle")
  }

  const { getRemainingTime } = useIdleTimer({
    timeout: deviceTimer ? deviceTimer * 1000 : idleTimeoutMs,
    onIdle: handleIdle,
    debounce: 500,
  })

  const remaining = getRemainingTime()

  const minutes = Math.floor(remaining / (1000 * 60)) % 60
  const seconds = Math.floor(remaining / 1000) % 60

  return (
    <>
      {minutes}:{`${seconds < 10 ? "0" : ""}${seconds}`}
    </>
  )
}

const IdleTimerAuthWrapper = ({ onLoggingOut }) => {
  const {
    authed,
    settings: { deviceTimer },
  } = useAuth()
  const {
    auth: { idleTimeoutMs },
    clientKiosk,
  } = Config.get()

  if (!authed || !clientKiosk || (clientKiosk && !idleTimeoutMs && !deviceTimer)) return null

  console.log("[AUTH]", "Idle timer is active...")

  return <IdleTimer onLoggingOut={onLoggingOut} />
}

export { IdleTimerAuthWrapper as IdleTimer }
